<template>
  <div class="object-list-container" :style="[xPosition, yPosition]">
    <div class="object-list-title">{{ title }}</div>

    <hr />

    <div class="list-container scroll-fire-fox">
      <object-list-item
        v-for="object in objectList"
        :key="object.type + object.id"
        :object="object"
        @selectObject="selectObject"
      />
    </div>
  </div>
</template>

<script>
import ObjectListItem from "./ObjectListItem";
import _ from "lodash";

export default {
  name: "ObjectList",

  components: { ObjectListItem },

  props: {
    coordinates: {
      type: Array,
      required: true
    },

    objectList: {
      type: Array,
      required: true
    }
  },

  computed: {
    xPosition() {
      let contentWidth = this.$parent.$refs.map.offsetWidth;
      let totalWidth = this.coordinates[0] + 140;
      if (totalWidth < contentWidth) {
        return { left: this.coordinates[0] + "px" };
      } else {
        return { right: 0 };
      }
    },

    yPosition() {
      let contentHeight = this.$parent.$refs.map.offsetHeight;
      let objectListSize;
      if (this.objectList.length > 6) {
        objectListSize = 132;
      } else {
        objectListSize = this.objectList.length * 22;
      }
      let totalHeight = this.coordinates[1] + 35 + objectListSize + 10;
      if (totalHeight < contentHeight) {
        return { top: +this.coordinates[1] + "px" };
      } else {
        return { bottom: 0 };
      }
    },

    actionType() {
      return this.$store.getters.tools_selectedAction;
    },

    title() {
      if (this.actionType === "create" || this.actionType === "move") {
        return this.$i18n.t("ConnectToObject");
      }
      return this.$i18n.t("ChooseMapElement");
    }
  },

  methods: {
    selectObject: _.debounce(function(object) {
      if (object.layerName === "fc_influence_line") {
        return;
      }
      this.$emit("selectObject", object);
      this.$emit("remove-highlight-from-menu");
    }, 500)
  }
};
</script>

<style scoped>
.object-list-container {
  position: absolute;
  z-index: 25;
  display: flex;
  flex-direction: column;
  min-width: 140px;
  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}
.object-list-title {
  font-weight: bold;
  padding: 10px;
  font-size: 12px;
}
.list-container {
  padding: 5px 0;
  max-height: 142px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectList/ObjectList.vue